import React from 'react';
import { string, object } from 'yup';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from '../FormResource.jsx';

const schema = object({
  name: string().required().label('Name'),
  address: string().required().label('Address'),
});

const defaults = {
  name: '',
  address: '',
};

const FormSupplier = ({
  supplier,
}) => (
  <FormResource
    {...{
      schema,
      defaults,
      stored: supplier,
      api: '/api/core/tfy/suppliers',
    }}
  >
    <div className="pt-3">
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
      <div className="row">
        <div className="col">
          <FormGroup name='name' label="Name" />
        </div>
        <div className="col">
          <FormGroup name='address' label="Address" />
        </div>
      </div>
    </div>
  </FormResource>
);

export default FormSupplier;
